var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 384,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    style: {
      fill: "#FF4B55"
    },
    width: 128,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M91.062,17.245l11.243,33.71l35.535,0.275c2.753,0.021,3.895,3.535,1.68,5.17l-28.586,21.11  l10.719,33.881c0.83,2.625-2.158,4.796-4.398,3.195l-28.91-20.664l-28.91,20.664c-2.24,1.601-5.228-0.57-4.398-3.195L65.755,77.51  L37.169,56.4c-2.215-1.635-1.073-5.149,1.68-5.17l35.535-0.275l11.243-33.71C86.497,14.633,90.191,14.633,91.062,17.245z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.a43364a9bf1d057c125e2741f120e2fe.svg";
export { ForwardRef as ReactComponent };